import { render, staticRenderFns } from "./TableauDocuments.vue?vue&type=template&id=09b9e4c2&"
import script from "./TableauDocuments.vue?vue&type=script&lang=js&"
export * from "./TableauDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TableauDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports